import React from 'react'

const TitleUpdated = () => {
  return (
    <div>TitleUpdated</div>
  )
}

export {TitleUpdated}